var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.1999H7.15C7.32239 10.1999 7.48772 10.1314 7.60962 10.0095C7.73152 9.88762 7.8 9.72229 7.8 9.5499C7.8 9.37751 7.73152 9.21218 7.60962 9.09028C7.48772 8.96838 7.32239 8.8999 7.15 8.8999H6.5V11.4999M11.05 10.1999H12.025M12.35 8.8999H11.05V11.4999M8.775 8.8999V11.4999H9.425C9.59739 11.4999 9.76272 11.4314 9.88462 11.3095C10.0065 11.1876 10.075 11.0223 10.075 10.8499V9.5499C10.075 9.37751 10.0065 9.21218 9.88462 9.09028C9.76272 8.96838 9.59739 8.8999 9.425 8.8999H8.775Z",
    stroke: "#273896",
    strokeWidth: 0.65,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 5.74276V16.5999H4V1.3999H10.5143M14.8571 5.74276L10.5143 1.3999M14.8571 5.74276H10.5143V1.3999",
    stroke: "#273896",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.fca20781471b2cb8e47e451e4d3cf5f0.svg";
export { ForwardRef as ReactComponent };